/* tslint:disable */
export var icon = "\n<svg width=\"14\" height=\"8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.212 7.168l2.142-2.1L8.387 0 4.949 3.183 2.127.347 0 2.463 4.864 7.35l3.422-3.169z\" fill-rule=\"evenodd\"/></svg>\n";
//# sourceMappingURL=lightning.svg.js.map